import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Input, Descriptions } from 'antd';

import './analytics.css';
import {
	opensearchGetUserProfile

} from '../../modules/analytics';

const { Search } = Input;

const initialState = {
	created_at:"",
	user_id:"",
	business_unit:"",
	display_name:"",
	email:"",
	mobile:"",
	is_receive:"",
	register_location:"",
	register_platform:"",
	subscription_status:"",
	subscription_type:"",
	subscription_start:"",
	subscription_expiry:"",
	loading:false,
	result:1 //1 First landing, 2 no results, 3 has results.
}
class UserManagmentCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	
	render() {
		let cc_data;
		const onSearch = (value, _e, info) => {
			this.setState({loading:true});
			 opensearchGetUserProfile('email='+value).then(data => {
				if(data.responses && data.responses[0] && data.responses[0].hits && data.responses[0].hits.hits && data.responses[0].hits.hits[0] && data.responses[0].hits.hits[0]._source )
				cc_data = data.responses[0].hits.hits[0]._source;
				if(cc_data){
					this.setState({
						created_at:cc_data.created_at, 
						user_id:cc_data.user_id,
						business_unit:cc_data.business_unit,
						display_name:cc_data.display_name,
						email:cc_data.email,
						mobile:cc_data.mobile,
						is_receive:cc_data.is_receive? 'Yes': 'No',
						register_location:cc_data.register_location,
						register_platform:cc_data.register_platform,
						subscription_status:cc_data.subscription_status,
						subscription_type:cc_data.subscription_type,
						subscription_start: cc_data.subscription_start?new Date(cc_data.subscription_start).toISOString():'',
						subscription_expiry:cc_data.subscription_expiry?new Date(cc_data.subscription_expiry).toISOString():'',
						loading:false,
						result: 3
						}
					)
				}else{
					this.setState({
						...initialState ,
						result: 2
					});
				}
			 })

		};
		return (
      		<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`User Profile Search  `}</h3>
				 <Search
					placeholder="Please input Email or User ID."
					allowClear
					size="large"
					onSearch={onSearch}
					enterButton 
					loading={this.state.loading}
    			/>
				{ this.state.result === 3  &&
				<Descriptions column={2}>
					<Descriptions.Item label="Email">{this.state.email}</Descriptions.Item>
					<Descriptions.Item label="User ID">{this.state.user_id}</Descriptions.Item>

					<Descriptions.Item label="Display Name">{this.state.display_name}</Descriptions.Item>
					<Descriptions.Item label="Mobile">{this.state.mobile}</Descriptions.Item>

					<Descriptions.Item label="Business Unit">{this.state.business_unit}</Descriptions.Item>
					<Descriptions.Item label="Receive Email">{this.state.is_receive}</Descriptions.Item>
					
					<Descriptions.Item label="Register Location">{this.state.register_location}</Descriptions.Item>
					<Descriptions.Item label="Register Platform">{this.state.register_platform}</Descriptions.Item>

					<Descriptions.Item label="Subscription Status">{this.state.subscription_status}</Descriptions.Item>
					<Descriptions.Item label="Subscription Type">{this.state.subscription_type}</Descriptions.Item>

					<Descriptions.Item label="Subscription Start">{this.state.subscription_start}</Descriptions.Item>
					<Descriptions.Item label="Subscription Expiry">{this.state.subscription_expiry}</Descriptions.Item>
					<Descriptions.Item label="Created At">{this.state.created_at}</Descriptions.Item>
					
				</Descriptions>
				}
				{
					this.state.result === 2 &&
					<div className='result'>No results.</div>
				}
				{
					this.state.result === 1 &&
					<div className='result'></div>
				}
     		</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserManagmentCard));
